import React from 'react';
import classNames from 'classnames';
import DefaultImage from '../../images/default-image.svg';

import './NoImage.module.scss';

class NoImage extends React.PureComponent {

  render() {
    const { isMobile } = this.props;

    return (
      <div styleName={classNames('container', { mobile: isMobile })}>
        <DefaultImage styleName="image" />
      </div>
    );
  }
}

export default NoImage;


// WEBPACK FOOTER //
// ./src/js/widgets/NoImage.js